export const REQUIRED_FIELD = 'This field is required'
export const max_string_msg = val => `Maximum ${val} characters`
export const max_digit_msg = val => `Maximum ${val} digits`
